import React from "react";
import { withRouteData } from "react-static";
import Hero from "@flow/scenes/home/components/hero/Hero";
import Partners from "@flow/components/partners/Partners";
import Footer from "@flow/components/footer/Footer";
import { IPage } from "types/IPage";
import { IPosts } from "types/IPosts";
import * as NavigationAction from "@flow/store/navigation/actions";
import { connect } from "react-redux";
import * as HomeComponents from "@flow/scenes/home/components";
import SEOTags from "@flow/components/seo/SEOTags";
import { IOptions } from "types/IOptions";
import { IPartners } from "types/IPartners";
import styled from "styled-components";
import BasicButton from "@flow/components/ui/button/BasicButton";

const PartnersWrapper = styled.div`
  margin-top: 6em;
  padding: 6em 3.6em;
  border-top: 0.1em solid ${(props) => props.theme.highlightColor};
  border-bottom: 0.1em solid ${(props) => props.theme.highlightColor};
`;

const PartnerCTAButton = styled.div`
  padding-left: 3em;
`;

const PartnersContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media only screen and (max-width: 1100px) {
    flex-direction: column;
    align-items: flex-start;

    ${PartnersWrapper} {
      margin-bottom: 5em;
    }

    ${PartnerCTAButton} {
      padding-left: 0;
      margin-top: 3em;
    }
  }
`;

interface Props {
  appLanguage: IAppLanguage;
  page: IPage;
  news?: IPosts;
  _setLanguage: any;
  options: IOptions;
  partners: IPartners;
}

class Home extends React.Component<Props> {
  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page: { lang_versions },
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  componentWillReceiveProps({ appLanguage, page: { lang_versions } }: Props) {
    const { _setLanguage } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  render() {
    const {
      appLanguage,
      options,
      page: { hero, slices },
      news,
      partners,
    } = this.props;

    const {
      partners_texts: { cta },
    } = appLanguage ? options[appLanguage.code] : options["fi"];

    const _createComponent = (slice: { layout: string }) => {
      let component: string;
      let props: Object = {};

      switch (slice.layout) {
        case "program":
          component = "ArtistLift";
          props = Object.assign(
            props,
            { program: slice },
            { appLanguage: appLanguage }
          );
          break;

        case "the_festival":
          component = "FestivalLift";
          props = { the_festival: slice };
          break;

        case "tickets_group":
          component = "TicketsLift";
          props = Object.assign(
            props,
            { tickets: slice },
            { appLanguage: appLanguage }
          );
          break;

        case "recent_news":
          component = "NewsLift";
          props = Object.assign(
            props,
            { ["recent_news"]: slice },
            { news: news },
            { appLanguage: appLanguage }
          );
          break;

        case "festival_reviews":
          component = "ReviewsLift";
          props = { reviews: slice };
          break;

        case "text_block":
          component = "TextLift";
          props = { content: slice };
          break;

        case "ads_block":
          component = "AdLift";
          props = { banners: slice };
      }

      if (!component) {
        return null;
      }

      return React.createElement((HomeComponents as any)[component], props);
    };

    const { page } = this.props;

    return (
      <div>
        <SEOTags page={page} />
        {Boolean(hero) && <Hero heroes={hero} />}
        {Boolean(slices) &&
          slices.map((slice: any, index: number) => (
            <div key={index}>{_createComponent(slice)}</div>
          ))}
        {partners && partners.length > 0 && (
          <PartnersWrapper>
            <PartnersContent>
              <Partners appLanguage={appLanguage} partners={partners} />
              <PartnerCTAButton>
                <BasicButton label={cta.label} href={cta.link.url} />
              </PartnerCTAButton>
            </PartnersContent>
          </PartnersWrapper>
        )}
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({ appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    },
  };
};

export default connect(null, mapDispatchToProps)(withRouteData(Home));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/home/Home.tsx